import Customer from 'features/customers/views/Customer'
import CustomerEdit from 'features/customers/views/CustomerEdit'
import Customers from 'features/customers/views/Customers'
import { UrlProvider } from 'urls'

import routeWithLayout from 'components/auth/routeWithLayout'

export default [
  routeWithLayout({ main: Customers, path: UrlProvider.getRawUrl('customers') }),
  routeWithLayout({ main: CustomerEdit, path: UrlProvider.getRawUrl('customer.edit') }),
  routeWithLayout({ main: Customer, path: UrlProvider.getRawUrl('customer') }),
]
